module.exports = __webpack_public_path__ + "img/link_building_graphic.fabc674e.svg";